import styled from 'styled-components';

const Wrapper = styled.aside`
  @media (min-width: 992px) {
    display: none;
  }

  .sidebar-container {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.7);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;
    opacity: 0;
    transition: opacity 0.25s, z-index 0s 0.25s;
  }

  .show-sidebar {
    z-index: 99;
    opacity: 1;
    transition: opacity 0.25s;
  }

  .content {
    background: linear-gradient(180deg, #0f172a 0%, #1e1b4b 100%);
    width: 88vw;
    max-width: 320px;
    height: 92vh;
    border-radius: 16px;
    padding: 1.5rem 1rem;
    position: relative;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);
  }

  .close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, 0.07);
    border: none;
    border-radius: 8px;
    font-size: 1.1rem;
    color: #94a3b8;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s, color 0.15s;
    &:hover { background: rgba(220, 38, 38, 0.15); color: #f87171; }
  }

  .nav-links {
    padding-top: 2.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
  }

  .nav-link {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    color: #64748b;
    padding: 0.7rem 0.875rem;
    border-radius: 10px;
    text-transform: capitalize;
    font-size: 0.9rem;
    font-weight: 500;
    text-decoration: none;
    transition: background 0.15s, color 0.15s;

    &:hover {
      background: rgba(255, 255, 255, 0.07);
      color: #e2e8f0;
      .icon { color: #818cf8; }
    }
  }

  .active {
    background: rgba(99, 102, 241, 0.15);
    color: #e0e7ff;
    font-weight: 600;
    .icon { color: #818cf8; }
  }

  .icon {
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    color: #475569;
    transition: color 0.15s;
  }
`;

export default Wrapper;
